import {
  ChronologicalData,
  GroupedData,
} from '../utils/chronological-data.interface';
import { GroupBy } from '../utils/group-by.enum';
import { GroupByStrategyBase } from './group-strategy-base.class';
import { GroupedChronologicalData } from '../utils/grouped-chronological-data.class';
import { getDataByDates } from '../utils/get-data-by-dates';
import { groupDatesByMonth } from '../utils/group-dates-by-month';

/* It groups the data by month */
export class GroupByMonthStrategy<T> extends GroupByStrategyBase<T> {
  locale: string | undefined;

  /**
   * It takes an array of chronological data, a group by option, and an optional
   * locale, and returns a grouped chronological data object
   * @param {ChronologicalData<T>[]} data - ChronologicalData<T>[]
   * @param {GroupBy} groupBy - GroupBy - this is the type of grouping you want to
   * do.
   * @param {string} [locale] - The locale to use for the grouping.
   * @returns A GroupedChronologicalData<T> object
   */
  group(
    data: ChronologicalData<T>[],
    groupBy: GroupBy,
    locale?: string
  ): GroupedChronologicalData<T> {
    this.locale = locale;
    const group = new GroupedChronologicalData<T>(groupBy);
    const dates = data.map((value) => value.date);

    const datesByMonth = groupDatesByMonth(dates, this.locale, 'MMM-yyyy');
    const grupedData = datesByMonth.map((weekGroup) => {
      const label = weekGroup.label;
      const dates = weekGroup.dates;

      const dataGroup = getDataByDates(data, dates, this.locale);

      return {
        label,
        dates,
        data: dataGroup,
      } as GroupedData<T>;
    });
    group.data = grupedData;

    return group;
  }
}
